/* eslint-disable camelcase */
import { Module } from 'vuex'
import { RootState } from '../types'
import api from '@/api/axios'

export interface TeamUser {
  id: number
  name: string
  email: string
  role: 'admin' | 'manager' | 'viewer'
  status: 'active' | 'invited' | 'disabled'
  created_at: string
}

export interface UsersState {
  list: TeamUser[]
  loading: boolean
}

const users: Module<UsersState, RootState> = {
  namespaced: true,

  state: (): UsersState => ({
    list: [],
    loading: false
  }),

  getters: {
    all: (state) => state.list,
    loading: (state) => state.loading
  },

  mutations: {
    SET_LIST (state, list: TeamUser[]) { state.list = list },
    SET_LOADING (state, val: boolean) { state.loading = val },
    ADD (state, user: TeamUser) { state.list.unshift(user) },
    UPDATE (state, updated: TeamUser) {
      const i = state.list.findIndex(u => u.id === updated.id)
      if (i !== -1) state.list.splice(i, 1, updated)
    },
    REMOVE (state, id: number) {
      state.list = state.list.filter(u => u.id !== id)
    }
  },

  actions: {
    async fetchAll ({ commit }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await api.get('/users')
        commit('SET_LIST', data.data ?? data)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async invite ({ commit }, payload: { name: string; email: string; role: string }) {
      const { data } = await api.post('/users/invite', payload)
      commit('ADD', data.data ?? data)
      return data
    },

    async updateRole ({ commit }, { id, role }: { id: number; role: string }) {
      const { data } = await api.patch(`/users/${id}/role`, { role })
      commit('UPDATE', data.data ?? data)
      return data
    },

    async remove ({ commit }, id: number) {
      await api.delete(`/users/${id}`)
      commit('REMOVE', id)
    }
  }
}

export default users
